import { Component, Input, OnInit } from "@angular/core";
import { DateHelper } from "apps/idl/src/helpers";
import { ETimetablePattern } from "apps/idl/src/model";
import { DestroyableComponentBase } from 'apps/idl/src/modules/utils/components/destroyable-component-base';
import { ContactsService } from "apps/idl/src/services/security";
import { FacturationService } from "apps/idl/src/modules/facturation/facturation.service";
import { Invoice } from "apps/idl/src/modules/facturation/models/invoice";
import { IPatient } from "apps/idl/src/modules/patients/model/IPatient";
import { Observable, forkJoin, from } from "rxjs";
import { mergeMap, takeUntil, tap } from 'rxjs/operators';
import { Traitement } from "../../../../../model/Traitement";
import { PatientsService } from "../../../../../modules/patients/services/patients.service";
import { PatientHelper } from "../../../shared/helpers/patient.helper";
import { DeviceService } from "../../../shared/services/device.service";
import { DrawerPopoverService } from "../../../shared/services/drawer-popover.service";
import { FacturationSVService } from "../../../shared/services/facturation-sv.service";
import { PanneauService } from "../../../shared/services/panneau.service";
import { SnackbarService } from "../../../shared/services/snackbar.service";
import { FacturationSvComponent } from "../facturation-sv/facturation-sv.component";
import { MenuFacturationPrepareeComponent } from "../menu-facturation-preparee/menu-facturation-preparee.component";

@Component({
	selector: "di-carte-facturation-preparee",
	templateUrl: "./carte-facturation-preparee.component.html",
	styleUrls: ["./carte-facturation-preparee.component.scss"],
})

export class CarteFacturationPrepareeComponent extends DestroyableComponentBase implements OnInit {
	@Input() invoice: Invoice
	@Input() checkbox: boolean = true;
	@Input() onCheck?: Function;
	@Input() checked: boolean = false;

	public isMobile: boolean = false;
	public total: number = 0;
	public adressePatient: string = '';
	public fullLastNamePatient: string = '';
	public fullFirstNamePatient: string = '';

	public dateInvoice: string = "";

	constructor(
		private svcDevice: DeviceService,
		private svcContact: ContactsService,
		private svcPatient: PatientsService,
		private svcDrawerPopover: DrawerPopoverService,
		private svcSnackbar: SnackbarService,
		private svcFacturation: FacturationService,
		private svcFacturationSV: FacturationSVService,
		private svcPanneau: PanneauService,
	) {
		super();
	}

	ngOnInit(): void {
		this.svcDevice.isMobile$
			.pipe(takeUntil(this.destroyed$))
			.subscribe((flag: boolean) => {
				this.isMobile = flag;
			});
		if (this.invoice) {
			if (this.invoice.preparationDate) {
				this.dateInvoice = DateHelper.transform(this.invoice.preparationDate, ETimetablePattern.dd_MM_yyyy_HH_mm_slash);
			}
			let patient$: Observable<IPatient>;
			if (!this.invoice.patient) {
				const patientId = Traitement.extractPatientId(this.invoice.traitementId);
				patient$ = this.svcPatient.getPatient(patientId).pipe(
					tap((patient: IPatient) => {
						this.invoice.patient = patient;
						this.adressePatient = this.getAdressePatient(this.invoice.patient);
						this.fullLastNamePatient = PatientHelper.getFullNamePatient(this.invoice.patient);
						this.fullFirstNamePatient = PatientHelper.getPatientFirstName(this.invoice.patient);

					})
				);
			} else {
				this.adressePatient = this.getAdressePatient(this.invoice.patient);
				this.fullLastNamePatient = PatientHelper.getFullNamePatient(this.invoice.patient);
				this.fullFirstNamePatient = PatientHelper.getPatientFirstName(this.invoice.patient);

			}

			let intervenant$ = null;
			if (!this.invoice.infirmier && this.invoice.intervenantId) {
				intervenant$ = this.svcContact.getContact(this.invoice.intervenantId).pipe(
					tap((intervenant) => {
						this.invoice.infirmier = intervenant;
					})
				);
			}

			if (intervenant$ && patient$) {
				forkJoin([patient$, intervenant$]).subscribe();
			} else if (intervenant$) {
				patient$.subscribe();
			} else if (patient$) {
				patient$.subscribe();
			}
		}

		this.total = this.invoice?.totalPartAMC + this.invoice?.totalPartAMO + this.invoice?.totalPartPatient
	}

	public getAdressePatient(pat: IPatient): string {
		if (!pat) return "";

		const addressParts: string[] = [];
		if (pat.street) {
			addressParts.push(pat.street);
		}
		if (pat.city) {
			addressParts.push(pat.city);
		}

		return addressParts.join(", ");
	}

	public facturer() {
		if (this.isMobile) {
			this.svcPanneau.close();
			this.svcDrawerPopover.open("Facturation SESAM-Vitale",
				"700px",
				null,
				FacturationSvComponent,
				{
					invoice: this.invoice,
					patient: this.invoice?.patient,
					closeButton: true,
				});
		} else {
			this.svcPanneau.open("Facturation SESAM-Vitale", FacturationSvComponent, {
				invoice: this.invoice,
				patient: this.invoice?.patient,
				closeButton: true,
			});
		}
	}

	public openMenu(event: Event) {
		this.svcDrawerPopover.open("", "auto", event.currentTarget, MenuFacturationPrepareeComponent, {
			annuler: this.annuler
		})
	}

	public handleCheck(event: Event) {
		this.checked = !this.checked;
		if (this.onCheck) this.onCheck(this.invoice, this.checked);
	}

	public annuler = () => {
		from(this.svcFacturation.annulerFacture(this.invoice.patientId, this.invoice, null, true, true)).pipe(
			mergeMap(() => this.svcFacturationSV.updateFacturesPrepareesBadgeCount()),
			tap(() => {
				this.svcSnackbar.showToast(
					"info",
					"bottom center",
					"Les soins sont à nouveau disponibles en facturation",
					null,
					null,
					null,
					"5000"
				);
				this.svcDrawerPopover.close();
				this.svcFacturation.invoiceChange(this.invoice._id);
			})
		).subscribe();
	}
}
